import Vue from 'vue'
import axios from 'axios'
import wx from 'weixin-js-sdk';
import { Toast } from 'vant';
Vue.prototype.axios = axios

//获取地址栏参数
// str = window.location.href.split('#')[0]
export function UrlSearch() {
  let name, value, str = window.location.href, num = str.indexOf("?"); //取得整个地址栏
  str = str.substr(num + 1); //取得所有参数 stringvar.substr(start [, length ]
  let arr = str.split("&"); //各个参数放到数组里
  let obj = {}
  for (let i = 0; i < arr.length; i++) {
    num = arr[i].indexOf("=");
    if (num > 0) {
      name = arr[i].substring(0, num);
      value = arr[i].substr(num + 1);
      obj[name] = value;
    }
  }
  return obj
}

//文件导出
export function exportFile(data) {
  window.open(data.url)
  // axios({
  //   method: 'get',
  //   url: data.url,
  //   // responseType: "blob"
  // })
  //   .then(res => {
  //     if (res.data.type) {
  //       window.open(data.url)
  //       // 文件下载
  //       // const blob = new Blob([res.data], {
  //       //   type: "application/vnd.ms-excel"
  //       //   // type: "application/octet-stream"
  //       // });
  //       // let link = document.createElement('a');
  //       // link.href = URL.createObjectURL(blob);
  //       // link.setAttribute('download', 'orders.xlsx');
  //       // link.click();
  //       // link = null;
  //       // console.log('导出成功');
  //     } else {
  //       // 返回json
  //       console.log(res.data.msg);
  //     }
  //   })
  //   .catch(() => {
  //     console.log("下载失败");
  //   });
}

// 获取签名
export function getShareInfo(data) {
  let typeId = data.typeId
  let shareImg = data.shareImg
  let titleData = data.titleData
  let qaDesc = data.qaDesc
  let linkUrl = data.linkUrl
  axios({
    method: 'post',
    url: data.geturl,
    // data:data.data,
    dataType: "json",
  })
    .then(res => {
      if (res.data.code === 20000) {
        sessionStorage.setItem('appId', res.data.data.appId);
        sessionStorage.setItem('signature', res.data.data.signature);
        sessionStorage.setItem('timestamp', res.data.data.timestamp);
        sessionStorage.setItem('nonceStr', res.data.data.nonceStr);
        sessionStorage.setItem('linkUrl', res.data.data.url);
        wxShare(titleData, qaDesc, typeId, shareImg, linkUrl);
        //data.productName,data.description,data.pid,data,aopenid
        console.log(data);
      }
    })
    .catch(() => {
      console.log("获取失败");
    });
}
// 分享productName,description,aopenid,pid
function wxShare(titleData, qaDesc, typeId, shareImg, linkUrl) {
  wx.config({
    debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: sessionStorage.getItem('appId'),// 必填，公众号的唯一标识
    timestamp: sessionStorage.getItem('timestamp'),// 必填，生成签名的时间戳
    nonceStr: sessionStorage.getItem('nonceStr'),// 必填，生成签名的随机串
    signature: sessionStorage.getItem('signature'),// 必填，签名
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']// 必填，需要使用的JS接口列表
  });

  wx.ready(function () {
    console.log(titleData);
    console.log(typeId);
    //需在用户可能点击分享按钮前就先调用
    wx.updateAppMessageShareData({
      title: titleData,
      desc: qaDesc,
      link: linkUrl + typeId,
      // link: 'https://dtfcloud.com/wx-tool/#/productPreview',
      imgUrl: shareImg,
      success() {
        console.log("分享成功")
      }
    });
    wx.updateTimelineShareData({
      title: titleData,
      desc: qaDesc,
      link: linkUrl + typeId,
      // link: 'https://dtfcloud.com/wx-tool/productPreview',
      imgUrl: shareImg,
      success() {
        console.log("分享成功")
      }
    })
  });
  wx.error(function (res) {
    //alert(res.errMsg);
    console.log(res)

  });
}
// 支付
var wxConfigure;
var Url;
export function jspay(data1) {
  Url = data1
  let data = {
    openid: sessionStorage.getItem("openId"),
    phone: sessionStorage.getItem("phone"),
    productName: 'u蜂巢会员',
    // ip: returnCitySN["cip"],
    ip: localStorage.getItem('cip'),
    money: '100',
  }
  axios({
    method: 'post',
    url: '/center/wx/js',
    data:data,
    dataType: "jsons",
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': '*'
    },
  })
    .then(res => {
      if (res.data.code === 20000) {
        wxConfigure = res.data.data
        isOnBridgeReady(wxConfigure, data1);
      }
    })
    .catch(() => {
      console.log("获取失败");
    });
}
export function jspay2(data) {
  console.log('======>jspay2')
  axios({
    method: 'post',
    url:process.env.VUE_APP_API+ '/center/wx/jsPayKw',
    data:data,
    dataType: "jsons",
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': '*'
    },
  })
    .then(res => {
      if (res.data.code === 20000) {
        wxConfigure = res.data.data
        isOnBridgeReady(wxConfigure, data);
      }
    })
    .catch(() => {
      console.log("获取失败");
    });
}

function onBridgeReady(wxConfigure, data1) {
  console.log('222',wxConfigure);
  console.log('333',data1);
  console.log('1111',wxConfigure.packageOne);
  Toast.clear();
  window.WeixinJSBridge.invoke(
    "getBrandWCPayRequest",
    {
      appId: wxConfigure.appId, //公众号名称，由商户传入
      // appId: "wxae0168c583647722", //公众号名称，由商户传入
      timeStamp: wxConfigure.timeStamp, //vm.getTimeStamp(2), //时间戳，自1970年以来的秒数1395712654
      nonceStr: wxConfigure.nonce_str, //, //随机串e61463f8efa94090b1f366cccfbbb444
      package: wxConfigure.packageOne, //vm.wxConfigure.packageOne,"prepay_id="+ wxConfigure.prepay_id
      signType: "MD5", //微信签名方式：
      paySign: wxConfigure.paySign //vm.wxConfigure.paySign //微信签名
    },
    function (res) {
      console.log("=====>看下面");
      console.log(res);
      Toast.loading({
        duration: 300, // 持续展示 toast
        forbidClick: true,
        message: "支付中..."
      });
      let status = true;
      if (res.err_msg !== "get_brand_wcpay_request:ok") {
        status = false;
      }
      sendPayResult(wxConfigure, status);
      if (status) {
        Toast("支付成功");
      } else {
        Toast("支付失败");
      }
      window.location.href = wxConfigure.successUrl;
    }
  );
}
function sendPayResult(wxInfo, status) {
  let data = {
    orderNo: wxInfo.out_trade_no,
    orderStatus: status ? '1' : '2',
    amount: wxInfo.total_fee
  }
  axios({
    method: 'post',
    url: '/gateway-api/center/kw/updatePayByOrderNo',
    data: data,
    dataType: "jsons",
    headers: {
      'Content-Type': 'application/json'
    },
  }).then(res => {
    console.log(res.data.code);
    if (res.data.code === 20000) {
      console.log(res.data.msg);
    }
  }).catch(() => {
    console.log("发送支付结果失败");
  });
}
function isOnBridgeReady(wxConfigure) {
  console.log('======>isOnBridgeReady')
  Toast.loading({
    duration: 300, // 持续展示 toast
    forbidClick: true,
    message: "正在跳转支付页面"
  });
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener(
        "WeixinJSBridgeReady",
        onBridgeReady,
        false
      );
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
    }
  } else {
    setTimeout(() => {
      Toast.clear();
    }, 1000);

    onBridgeReady(wxConfigure);
  }
}
// sessionStorage判断
export function setSession(key, value) {
  if (key != null && value != null && value != '' && value != undefined && value != 'undefined') {
    sessionStorage.setItem(key, value);
  }
}
// localStorage判断
export function setLocal(key, value) {
  if (key != null && value != null && value != '' && value != undefined && value != 'undefined') {
    localStorage.setItem(key, value);
  }
}
export default {
  exportFile,
  //   getShareInfo,
  UrlSearch,
  jspay,
  setSession,
  setLocal,
  jspay2
}

